import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PlanModalService {
  readonly open$ = new Subject<void>();

  open(): void {
    this.open$.next();
  }
}
